<div class="svg-loader" *ngIf="isLoading"></div>
<div class="largeModelContainer" *ngIf="!isLoading">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle alignCenter ">
    Send Data Specification - {{componentDetails.componentUniqueId}}
  </div>
  <div class="modelBody">
    <form [formGroup]="sendDataForm">
      <div class="pad-lr">
        <div class="form-group row">
          <label for="dataSourceId" class="col-4 mt-2 largeText mandatory-field">Data Source</label>
          <div class="col-8">
            <select id="dataSourceId" (change)="onDurationTypeSelected($event)" class="form-control select-btn" required formControlName="dataSourceId" [disabled]="readOnly">
              <option *ngFor="let element of dataSourceList" [ngValue]="element.datasourceId">{{element.datasourceName}}</option>
            </select>
          </div>
        </div>
      </div>
    </form>
    <div class="d-flex alignCenter">
      <button id="createBtn" type="submit" class="saveBtn2 primaryBtn" (click)="savesendDataSpecifications()" [disabled]="disableSave()">Save</button>
    </div>
  </div>
</div>
